import styled from 'styled-components';

import { colors, radius } from '../../styles/tokens';

export const Container = styled.div`
  width: 100%;
  min-width: 460px;

  display: flex;
  flex-direction: column;

  background-color: ${colors.surfaceContainerLow};

  @media (max-width: 1199px) {
    min-width: auto;
  }
`;

export const Content = styled.div`
  padding: 16px 20px 20px;
  max-height: 70vh;
  overflow-y: auto;
`;

export const MarkAllRow = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 8px;
`;

export const MarkAllButton = styled.button`
  padding: 6px 4px;

  background: transparent;
  border: none;
  cursor: pointer;

  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: ${colors.primary};

  &:hover {
    text-decoration: underline;
  }
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Item = styled.button<{ unread: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  width: 100%;

  padding: 12px 10px;
  border-radius: ${radius.DEFAULT};
  border: none;
  cursor: pointer;
  text-align: left;

  background-color: ${props =>
    props.unread ? `${colors.primary}14` : 'transparent'};

  transition: background-color 0.15s;

  &:hover {
    background-color: ${props =>
      props.unread ? `${colors.primary}22` : colors.surfaceContainer};
  }
`;

export const ItemDot = styled.span<{ unread: boolean }>`
  flex-shrink: 0;
  margin-top: 6px;

  width: 7px;
  height: 7px;
  border-radius: ${radius.full};

  background-color: ${props => (props.unread ? colors.primary : 'transparent')};
`;

export const ItemContent = styled.div`
  min-width: 0;
`;

export const ItemTitle = styled.p`
  font-size: 13.5px;
  font-weight: 700;
  color: ${colors.onSurface};
`;

export const ItemBody = styled.p`
  font-size: 12.5px;
  color: ${colors.onSurfaceVariant};
  line-height: 1.5;
  margin-top: 2px;
`;

export const ItemDate = styled.p`
  font-size: 10.5px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${colors.onSurfaceVariant}b3;
  margin-top: 6px;
`;

export const LoadMoreButton = styled.button`
  display: block;
  width: 100%;
  margin-top: 8px;
  padding: 10px;

  background: transparent;
  border: 1px solid ${colors.outlineVariant};
  border-radius: ${radius.DEFAULT};
  cursor: pointer;

  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: ${colors.onSurfaceVariant};

  &:hover {
    background-color: ${colors.surfaceContainer};
  }
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  text-align: center;

  padding: 40px 20px;

  span {
    color: ${colors.onSurfaceVariant};
    font-size: 13px;
  }
`;
